import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MainState } from './state';

const defaultState: MainState = {
  token: '',
  isLoggedIn: null,
  loginError: null,
  ssoError: null,
  profile: null,
  profileError: null,
  passwordError: null,
  dashboardShowDrawer: true,
  notifications: [],
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
